import { forwardRef, HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
        <div
            ref={ref}
            className={cn(
                'min-w-0 rounded-2xl border border-tg-border bg-white text-tg-ink shadow-[var(--tg-shadow-card)] transition-[border-color,box-shadow] duration-200',
                className,
            )}
            {...props}
        />
    ),
);
Card.displayName = 'Card';

export const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
        <div
            ref={ref}
            className={cn('flex min-w-0 flex-col space-y-1.5 p-5', className)}
            {...props}
        />
    ),
);
CardHeader.displayName = 'CardHeader';

export const CardTitle = forwardRef<HTMLHeadingElement, HTMLAttributes<HTMLHeadingElement>>(
    ({ className, ...props }, ref) => (
        <h3
            ref={ref}
            className={cn('text-[15px] font-bold leading-tight text-tg-ink [overflow-wrap:anywhere]', className)}
            {...props}
        />
    ),
);
CardTitle.displayName = 'CardTitle';

export const CardDescription = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
    ({ className, ...props }, ref) => (
        <p
            ref={ref}
            className={cn('text-sm text-tg-muted [overflow-wrap:anywhere]', className)}
            {...props}
        />
    ),
);
CardDescription.displayName = 'CardDescription';

export const CardContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
        <div ref={ref} className={cn('min-w-0 p-5 pt-0', className)} {...props} />
    ),
);
CardContent.displayName = 'CardContent';
